import { render, staticRenderFns } from "./trainCategory.vue?vue&type=template&id=3c0ce6c6&scoped=true&"
import script from "./trainCategory.vue?vue&type=script&lang=js&"
export * from "./trainCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ce6c6",
  null
  
)

component.options.__file = "trainCategory.vue"
export default component.exports